(function () {
    'use strict';

    angular
        .module('papp')
        .controller('RoadMaintenanceModalController', RoadMaintenanceModalController);

    RoadMaintenanceModalController.$inject = ['$uibModalInstance', 'message', 'Notification'];

    function RoadMaintenanceModalController($uibModalInstance, message, Notification) {
        var vm = this;
        vm.message = message;
        vm.lastNotification = Notification.dieselNotificationLast.getLast();

        vm.ok = ok;
        vm.cancel = cancel;

        function ok() {
            $uibModalInstance.close(message);
        }

        function cancel() {
           $uibModalInstance.dismiss();
        }
    }
})();
